export const ERROR_MESSAGE_1 =
  'Hmm, something went wrong. Please try again later.'
